import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { multiFormatUploader } from "../../../../services/fetcher";
import { Paper } from "@mantine/core";
import AddOperatorForm from "../../forms/AddOperatorForm/AddOperatorForm";
import {
  successNotifications,
  errorNotifications,
} from "../../../../utils/handleNotifications";

const endpoint = "operator/operator-profiles/";

const appendFormValue = (formData, key, value) => {
  if (value === null || value === undefined || value === "") return;

  if (Array.isArray(value)) {
    value.forEach((item) => {
      if (item !== null && item !== undefined && item !== "") {
        formData.append(key, item);
      }
    });
    return;
  }

  formData.append(key, value);
};

const AddOperator = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const addOperatorMutation = async (newOperator) => {
    setIsSubmitting(true);
    try {
      await multiFormatUploader(endpoint, "POST", newOperator);
      successNotifications("Success! Operator profile created");
      navigate(-1);
    } catch (error) {
      console.error(error);
      errorNotifications(error?.response?.data, error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleAddOperator = (payload) => {
    const formData = new FormData();
    const data = {
      designation: "Operator",
      permission: "Operator",
      department_name: "Operators",
      ...payload,
    };

    Object.entries(data).forEach(([key, value]) => {
      appendFormValue(formData, key, value);
    });

    addOperatorMutation(formData);
  };

  return (
    <Paper
      radius={8}
      withBorder
      maw={952}
      mx="auto"
      bg="#FFFFFF"
    >
      <AddOperatorForm onSubmit={handleAddOperator} isSubmitting={isSubmitting} />
    </Paper>
  );
};

export default AddOperator;